import { constructs } from "../api/contructs";
import { CreateGenericReducer } from "./CreateGenericReducer";

export const SubscriptionsReducer = CreateGenericReducer(constructs.subscription);
